export default "__VITE_ASSET__8nWwqa2u__"